import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { invalidateAllAutomationTemplatesQueries } from '../../queries/useAutomationTemplatesQuery';

export const useDuplicateAutomationTemplateMutation = ({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			id,
			name,
			impersonationContext,
		}: {
			id: string;
			name: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(id)}/clone`,
					impersonationContext,
					queryParams: {
						name,
					},
				}),
				'POST'
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllAutomationTemplatesQueries();
			onSuccess?.(data);
		},
	});
};
